export const warning = (...args) => {
    console.warn(args);
};
